<div class="content-wrapper table-full-bx">
	<div class="account-settings">
		<div class="row">
			<div class="col-lg-12">
				<div class="ibox ">
					<div class="ibox-body">
						<div class="iboxcontent">
							<h3>Account Settings</h3> 
						</div>
						<!-- Account settings  -->
						<div class="row">
							<div class="col-md-12 col-lg-3 col-sm-12">
								<!-- Tabs nav -->
								<div class="nav  nav-pills nav-pills-custom pills-custom">
									<a class="nav-link mb-3 p-3 " href="javascript:void(0);" routerLink="/account-settings/change-password"> <span class="">Change Password</span> </a>
									<a class="nav-link mb-3 p-3  " href="javascript:void(0);" routerLink="/account-settings/notification" *ngIf="userDatas?.Recruiter?.userType != 'SUB_RECRUITER'"> <span class="">Notifications</span> </a>
									<a class="nav-link mb-3 p-3 " href="javascript:void(0);" routerLink="/account-settings/save-card" *ngIf="userDatas?.Recruiter?.userType != 'SUB_RECRUITER'" hidden> <span class="">Saved cards</span> </a>
									<a class="nav-link mb-3 p-3  active" href="javascript:void(0);" routerLink="/account-settings/inventory-history"  *ngIf="userDatas?.Recruiter?.userType == 'SUPER_RECRUITER' || (userDatas?.Recruiter?.userType == 'SUB_RECRUITER' && userPermissionData?.viewActivePlans == 1)"> <span class="">Subscriptions</span> </a>
									<a class="nav-link mb-3 p-3 " href="javascript:void(0);" routerLink="/account-settings/billing-address" *ngIf="userDatas?.Recruiter?.userType != 'SUB_RECRUITER'"> <span class="">Billing address</span> </a>
									<a class="nav-link mb-3 p-3  " href="javascript:void(0);" routerLink="/account-settings/my-templates" *ngIf="userDatas?.Recruiter?.userType != 'SUB_RECRUITER'"> <span class="">My templates</span> </a>
								</div>
							</div>

							<div class="col-md-12 col-lg-9 col-sm-12">
								<section class="subscription">
									<div class="headingdiv">
										<h4 class="heading-5">Ease your talent acquisition</h4>
									</div>
									<ul class="nav nav-pills sub">
										<li *ngIf="userDatas?.Recruiter?.userType != 'SUB_RECRUITER'">
											<a href="javascript:void(0)" routerLink="/account-settings/subscription/subscription-plan"> Subscription plans</a>
										</li>
										<li class="active"><a href="javascript:void(0)" routerLink="/account-settings/inventory-history/inventory-plan"> Inventory purchase </a></li>
									</ul>
									<p class="para">Purchase clicks and search candidates from the pool as per your requirement</p>
									<form  [formGroup]="form" class="text-left pd-tb" (ngSubmit)="redirectTo()">
										<div class="row">
											<div class="col-sm-12 selectnumber">
												<p>Select number of clicks and the duration</p>
											</div>
											<div class="col-sm-12 col-lg-5 col-md-5">
												<div class="form-group">
													<label>Duration</label>
													<select class="form-control" (click)="change($event)" formControlName="id" id="id" [(ngModel)]="selectedDuration" name="selectedDuration">
														<option [ngValue]="null" [disabled]="true" selected="true"> Please select</option>
														<!-- <option hidden value="" [disabled]="true" [selected]="true"> Please select</option> -->
														<option *ngFor="let duration of allPlans; let i =index;" [value]="duration.id">{{duration.validity}} {{duration.validityType}}</option>
													</select>
												</div>
											</div>
							
											<div class="col-sm-12 col-lg-5 col-md-5">
												<div class="form-group">
													<label>Number of clicks</label>
													<select class="form-control" readOnly>
														<option>{{clicks!= null ? clicks + " clicks" : "0 clicks"}} </option>
													</select>
												</div>
											</div>
							
											<div class="col-sm-12 col-lg-2 col-md-2">
												<div class="form-group">
													<label>Amount</label>
													<p class="amount orangeText">$ {{amount || "0"}}</p>
												</div>
											</div>
										</div>
							
										<p class="para6"><img src="../../../../assets/images/info.svg" class="ht" /> Clicks will be counted when a candidate resume is downloaded, candidate profile is forwarded or an email is sent to the candidate.</p>
							
										<div class="row">
											<div class="col-sm-6 col-lg-6 col-md-6 pt-4">
												<input type="submit"  value="Add to cart" class="planbtn fill" [disabled]="!(amount)"/>
											</div>
										</div>
									</form>
								</section>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>